import React from 'react';
import { StateProps } from './types';

export const TableRow = ({ rowClasses = [], children }: StateProps) => {
	return <tr className={rowClasses.join(' ')}>
		{children}
	</tr>;
};